(() => {
  if (window.hgBookingLarkLoaded) return;
  window.hgBookingLarkLoaded = true;

  let loader;

  function loadWidget() {
    if (window.turnstile) {
      return Promise.resolve(window.turnstile);
    }

    if (!loader) {
      loader = new Promise((resolve, reject) => {
        window.hgBookingTurnstileReady = () => {
          resolve(window.turnstile);
        };

        const script = document.createElement("script");

        script.src =
          "https://challenges.cloudflare.com/turnstile/v0/api.js?onload=hgBookingTurnstileReady&render=explicit";

        script.async = true;

        script.onerror = () => {
          reject(
            new Error(
              "Verification could not load. Please refresh."
            )
          );
        };

        document.head.append(script);
      });
    }

    return loader;
  }

  function init(root = document) {
    root
      .querySelectorAll('[data-lark-booking="true"]')
      .forEach((section) => {
        if (section.dataset.bookingReady) return;

        section.dataset.bookingReady = "true";

        const form = section.querySelector("form");

        if (!form) return;

        const button = form.querySelector('[type="submit"]');

        const message = form.querySelector(
          "[data-booking-message]"
        );

        const host = form.querySelector(
          "[data-booking-verification]"
        );

        let token = "";
        let busy = false;
        let widget;
        let api;

        const report = (text) => {
          if (message) {
            message.textContent = text;
          }
        };

        const reset = () => {
          token = "";

          button.disabled = true;

          if (api && widget !== undefined) {
            api.reset(widget);
          }
        };

        form.addEventListener(
          "submit",
          async (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();

            if (
              busy ||
              !token ||
              !form.reportValidity()
            ) {
              return;
            }

            const data = new FormData(form);

            const payload = {
              name: data.get("contact[name]"),

              phone: data.get("contact[phone]"),

              email: data.get("contact[email]"),

              message: data.get("contact[Message]"),

              consent:
                data.get("contact[Contact consent]") ===
                "Agreed"
            };

            /*
              Generate a stable request reference
              for retries of the same submission.
            */
            const digest =
              await crypto.subtle.digest(
                "SHA-256",
                new TextEncoder().encode(
                  JSON.stringify(payload)
                )
              );

            const key =
              "hase-booking-" +
              Array.from(
                new Uint8Array(digest),
                (number) =>
                  number
                    .toString(16)
                    .padStart(2, "0")
              ).join("");

            let id = crypto.randomUUID();

            try {
              id =
                sessionStorage.getItem(key) || id;

              sessionStorage.setItem(
                key,
                id
              );
            } catch (error) {
              // sessionStorage unavailable
            }

            busy = true;

            button.disabled = true;

            report("Sending your enquiry…");

            try {
              const response = await fetch(
                section.dataset.bookingEndpoint,
                {
                  method: "POST",

                  headers: {
                    "Content-Type":
                      "application/json"
                  },

                  signal:
                    AbortSignal.timeout(40000),

                  body: JSON.stringify({
                    ...payload,

                    requestId: id,

                    turnstileToken: token
                  })
                }
              );

              let result;

              try {
                result = await response.json();
              } catch {
                throw new Error(
                  "Unexpected server response. Please try again."
                );
              }

              if (
                !response.ok ||
                result.ok !== true
              ) {
                throw new Error(
                  (result.error ||
                    "We could not confirm your enquiry.") +
                    (result.requestId
                      ? " Reference: " +
                        result.requestId
                      : "")
                );
              }

              report(
                section.dataset.bookingSuccess ||
                  "Thank you. Your enquiry has been received."
              );

              form.reset();
            } catch (error) {
              if (
                error.name === "TimeoutError"
              ) {
                report(
                  "We could not confirm your enquiry. Please contact us with reference " +
                    id
                );
              } else {
                report(
                  error.message ||
                    "Something went wrong. Please try again."
                );
              }
            } finally {
              busy = false;

              reset();
            }
          },
          true
        );

        loadWidget()
          .then((turnstile) => {
            api = turnstile;

            widget = api.render(host, {
              sitekey:
                section.dataset.bookingSitekey,

              action: "booking",

              callback: (value) => {
                token = value;

                if (!busy) {
                  button.disabled = false;
                }
              },

              "expired-callback": () => {
                token = "";

                button.disabled = true;
              },

              "error-callback": () => {
                token = "";

                button.disabled = true;

                report(
                  "Verification could not complete. Please refresh or contact us."
                );
              }
            });
          })
          .catch((error) => {
            report(error.message);
          });
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => init(),
      {
        once: true
      }
    );
  } else {
    init();
  }

  document.addEventListener(
    "shopify:section:load",
    (event) => {
      init(event.target);
    }
  );
})();